<script setup lang="ts">
import type { ReadonlyDeep } from 'type-fest';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { computed } from 'vue';

import { getStrCell } from '@/utils/file';
import KBtn from '@/components/btns/KBtn.vue';
import NewAirRoadProductSizeText from '@/components/texts/NewAirRoadProductSizeText.vue';
import NewAirRoadProductWeightText from '@/components/texts/NewAirRoadProductWeightText.vue';

export interface Props {
  product?: ReadonlyDeep<
    Required<openapi.AirroadSingleCreateBodyOpenapi['items'][0]>['products'][0]
  >;
  pickupProducts?: ReadonlyDeep<
    Partial<
      openapi.AirroadJobDetailedContentOpenapi['stops'][0]['pickup_products'][0]
    >[]
  >;
  productNum?: number;
}
const props = withDefaults(defineProps<Props>(), {
  product: () => ({}),
  pickupProducts: () => [],
  productNum: 0,
});
const emit = defineEmits<{
  productUnpack: [productNum: number];
}>();

const pickupProduct = computed(function () {
  const _pickupProduct = props.pickupProducts.find(function (onePickupProduct) {
    return onePickupProduct._id === props.product.product_id;
  });
  return _pickupProduct || {};
});

function handleUnpackCick(): void {
  emit('productUnpack', props.productNum);
}
</script>

<template>
  <li
    :class="$style.newAirRoadPackagedProductsBasicListItem"
    data-testid="newAirRoadPackagedProductsBasicListItem"
  >
    <div :class="$style.left">
      <div :class="$style.quantityAndModel">
        <div :class="$style.quantity">{{
          getStrCell(props.product.quantity)
        }}</div>
        {{ getStrCell(pickupProduct.model) }}
      </div>
      <div :class="$style.sizeAndWeight">
        <div>
          <NewAirRoadProductSizeText :product="pickupProduct" />
        </div>
        <div>
          <NewAirRoadProductWeightText :product="pickupProduct" />
        </div>
      </div>
    </div>
    <div :class="$style.right">
      <KBtn
        priority="info"
        variant="outlined"
        size="xs"
        @click="handleUnpackCick"
      >
        Unpack
      </KBtn>
    </div>
  </li>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.newAirRoadPackagedProductsBasicListItem {
  line-height: 1.4;
  list-style-type: none;
  padding: 16px;
  border-top: 1px solid colors.$color-gray-200;
  border-bottom: 1px solid colors.$color-gray-200;
  display: flex;
  gap: 8px;
}
  .left {
    width: 100%;
  }
    .quantityAndModel {
      display: flex;
      gap: 8px;
    }
      .quantity {
        border-radius: 50%;
        border: 1px solid colors.$color-text-primary;
        font-size: 14px;
        height: 24px;
        min-width: 24px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }
    .sizeAndWeight {
      display: flex;
      align-items: center;
      gap: 16px;
      margin-top: 8px;
    }
  .right {
  }
</style>
